import type { Benefit, FaqItem, Stat, Step, Testimonial, TreatmentArea } from '../types/landing'

export const stats: Stat[] = [
  { value: '#1', label: 'Energy-based aesthetic device worldwide' },
  { value: '4M+', label: 'Treatments performed globally' },
  { value: '0', label: 'Days of downtime after your visit' },
  { value: '90', label: 'Minutes or less in the chair' },
]

export const benefits: Benefit[] = [
  {
    title: 'Lift without surgery',
    body: 'Focused ultrasound reaches the same foundational layer surgeons address — without a single incision.',
    icon: 'lift',
  },
  {
    title: 'See inside as we treat',
    body: 'Real-time imaging lets your provider see beneath the surface and place energy exactly where it counts.',
    icon: 'scan',
  },
  {
    title: 'Your own collagen',
    body: 'No fillers, no foreign material. Your body rebuilds collagen and elastin over the following months.',
    icon: 'collagen',
  },
  {
    title: 'Back to life the same day',
    body: 'Most people return to work, the gym, or dinner plans straight from the appointment.',
    icon: 'clock',
  },
]

export const treatmentAreas: TreatmentArea[] = [
  { name: 'Brow', note: 'Lifts a heavy or hooded brow line' },
  { name: 'Jawline', note: 'Redefines a softening jaw' },
  { name: 'Neck', note: 'Tightens crepey, lax skin' },
  { name: 'Décolletage', note: 'Smooths lines on the chest' },
  { name: 'Abdomen', note: 'FDA-cleared for laxity' },
  { name: 'Arms & knees', note: 'Newest cleared areas' },
]

export const steps: Step[] = [
  {
    title: 'Book your free consult',
    body: 'Tell us your zip code and what bothers you. We match you with a certified provider near you, usually within one business day.',
  },
  {
    title: 'Get a personalized plan',
    body: 'Your provider maps your face and neck with live ultrasound imaging and shows you exactly what is treatable.',
  },
  {
    title: 'One treatment, 60–90 minutes',
    body: 'Comfort options are available throughout. You walk out and go straight back to your day.',
  },
  {
    title: 'Results build for 3–6 months',
    body: 'Collagen regenerates gradually, so the lift looks like you on a very good day — never overdone.',
  },
]

export const testimonials: Testimonial[] = [
  {
    quote:
      'I kept putting off a facelift because I could not take three weeks off. One appointment, and by month three my jawline looked like it did in my early forties.',
    name: 'Denise R.',
    detail: 'Treated jawline & neck · Scottsdale, AZ',
    featured: true,
  },
  {
    quote: 'No needles, no bruising. I was back at my desk the same afternoon.',
    name: 'Marisol P.',
    detail: 'Treated brow · Chicago, IL',
  },
  {
    quote: 'My provider showed me the ultrasound image of my own tissue. That is when I trusted it.',
    name: 'Karen L.',
    detail: 'Treated full face · Tampa, FL',
  },
]

export const faqs: FaqItem[] = [
  {
    q: 'Does it hurt?',
    a: 'You will feel heat and tingling in waves as the ultrasound energy is delivered — a sign collagen stimulation is happening. Your provider can adjust settings and offer comfort measures throughout, and discomfort ends when the treatment does.',
  },
  {
    q: 'How soon will I see a difference?',
    a: 'Some people notice an initial lift right away. The meaningful change appears gradually over 3 to 6 months as your body produces new collagen and elastin.',
  },
  {
    q: 'How long does it last?',
    a: 'Results typically hold for a year or more. Because the treatment works with your natural aging process, many people schedule a maintenance session annually.',
  },
  {
    q: 'What does it cost?',
    a: 'Pricing depends on the areas treated and your provider. Most consultations are complimentary, and many practices offer financing. Your matched provider will quote you before anything is scheduled.',
  },
  {
    q: 'Am I a candidate?',
    a: 'The best candidates have mild to moderate skin laxity — a softening jawline, a heavy brow, or crepey skin on the neck or chest. A consultation with a certified provider is the only way to know for sure, and it is free.',
  },
]

export const guideChecklist: string[] = [
  'The 9 questions to ask before you book anything',
  'How to tell a certified provider from a discount clinic',
  'Realistic month-by-month results timeline',
  'What a fair price range looks like in your area',
  'Red flags that mean you should walk away',
]
